import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';

function create(name) {
  var _temp;

  var Base = React[name];
  return _temp =
  /*#__PURE__*/
  function (_Base) {
    _inherits(_temp, _Base);

    var _super = _createSuper2(_temp);

    function _temp() {
      var _this;

      _classCallCheck(this, _temp);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args));
      _this.$isMounted = void 0;
      _this.forceUpdateTimer = void 0;
      return _this;
    }

    _createClass(_temp, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.$isMounted = true;
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.$isMounted = false;
      }
    }, {
      key: "setState",
      value: function setState() {
        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        if (this.$isMounted !== false) _get(_getPrototypeOf(_temp.prototype), "setState", this).apply(this, args);
      }
    }, {
      key: "forceUpdate",
      value: function forceUpdate() {
        if (this.$isMounted === true) _get(_getPrototypeOf(_temp.prototype), "forceUpdate", this).call(this);

        if (this.$isMounted === undefined) {
          if (this.forceUpdateTimer) clearTimeout(this.forceUpdateTimer);
          this.forceUpdateTimer = setTimeout(this.forceUpdate.bind(this));
        }
      }
    }]);

    return _temp;
  }(Base), _temp;
}

export var Component = create('Component');
export var PureComponent = create('PureComponent');